import { IonBackButton } from "@ionic/react";
import { forwardRef } from "react";
import { chevronLeftIcon } from "@/lib/icons/chevron-left.icon";
import { cx } from "@/lib/style/cva.config";

export const BackButton = forwardRef<
  HTMLIonBackButtonElement,
  React.ComponentProps<typeof IonBackButton>
>(function BackButton(props, ref) {
  return (
    <IonBackButton
      ref={ref as any}
      icon={chevronLeftIcon}
      text=""
      {...props}
      className={cx(
        "touch-target part-icon:m-0 part-icon:size-6 part-native:size-10",
        props.className,
      )}
    />
  );
});
